var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 47,
    viewBox: "0 0 49 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.7758 21.4089L37.9168 29.9743L40.8701 42.7268C41.0264 43.3935 40.9818 44.0912 40.7419 44.7328C40.502 45.3743 40.0774 45.9313 39.5213 46.3339C38.9652 46.7366 38.3022 46.9672 37.6152 46.9967C36.9281 47.0263 36.2476 46.8537 35.6586 46.5003L24.4858 39.7541L13.337 46.5003C12.748 46.8537 12.0675 47.0263 11.3805 46.9967C10.6934 46.9672 10.0304 46.7366 9.4743 46.3339C8.91817 45.9313 8.49363 45.3743 8.25373 44.7328C8.01384 44.0912 7.96925 43.3935 8.12553 42.7268L11.0745 29.9874L1.2133 21.4089C0.691728 20.9611 0.31458 20.3699 0.129147 19.7096C-0.0562862 19.0493 -0.041749 18.3491 0.170935 17.697C0.383619 17.0448 0.784982 16.4697 1.32469 16.0437C1.8644 15.6178 2.51844 15.3599 3.20477 15.3025L16.2029 14.1818L21.2767 2.1344C21.5417 1.50226 21.9886 0.962283 22.5612 0.582474C23.1338 0.202664 23.8065 0 24.4945 0C25.1826 0 25.8553 0.202664 26.4279 0.582474C27.0005 0.962283 27.4474 1.50226 27.7124 2.1344L32.8015 14.1818L45.7952 15.3025C46.4816 15.3599 47.1356 15.6178 47.6753 16.0437C48.215 16.4697 48.6164 17.0448 48.8291 17.697C49.0417 18.3491 49.0563 19.0493 48.8709 19.7096C48.6854 20.3699 48.3083 20.9611 47.7867 21.4089H47.7758Z",
    fill: "#D1D439"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.61196d45ae6ee3fe35678f5ff29c75af.svg";
export { ForwardRef as ReactComponent };